import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitleDefault from '../default/DialogTitleDefault';
import { Box, Divider, Grid, Typography, useTheme } from '@mui/material';
import PersonAddAlt1Icon from '@mui/icons-material/PersonAddAlt1';
import PersonSearchIcon from '@mui/icons-material/PersonSearch';
import PaymentIcon from '@mui/icons-material/Payment';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import MoneyOffIcon from '@mui/icons-material/MoneyOff';
import { showModal } from 'react-redux-modal-provider';
import ModalDirEntregaUpdate from '../notificaciones/ModalDirEntregaUpdate';
import ModalNoVeoServicio from '../servicio/ModalNoVeoServicio';
import ModalValidarTarjeta from '../softland/ModalValidarTarjeta';
import ModalCrearClienteEventual from '../eventual/ModalCrearClienteEventual';
import ModalDeleteClienteEventual from '../eventual/ModalDeleteClienteEventual';
import ModalBajaDebitoRechazado from '../softland/ModalBajaDebitoRechazado';
import usePermisos from '../../hooks/usePermisos';

const AccionCard = ({ icon, title, subtitle, onClick, color = '#1976d2', disabled = false }) => {
    const theme = useTheme();
    const isDarkMode = theme.palette.mode === 'dark';
    return (
        <Box
            onClick={disabled ? undefined : onClick}
            sx={{
                width: 130,
                height: 130,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 0.5,
                borderRadius: 3,
                cursor: disabled ? 'not-allowed' : 'pointer',
                border: `2px solid ${isDarkMode ? '#3d4a62' : '#e0e0e0'}`,
                background: isDarkMode ? '#253147' : '#f9f9f9',
                transition: 'all 0.18s ease',
                px: 1,
                opacity: disabled ? 0.45 : 1,
                '&:hover': disabled ? {} : {
                    background: isDarkMode ? '#2e3d57' : '#eaf2ff',
                    borderColor: color,
                    transform: 'translateY(-2px)',
                    boxShadow: `0 4px 14px ${color}33`,
                },
            }}
        >
            <Box sx={{ color, fontSize: 32, display: 'flex' }}>{icon}</Box>
            <Typography sx={{ fontWeight: 'bold', fontSize: 11, color: isDarkMode ? '#fff' : '#111', textAlign: 'center', lineHeight: 1.2 }}>
                {title}
            </Typography>
            <Typography sx={{ fontSize: 10, color: isDarkMode ? '#9aa8be' : '#777', textAlign: 'center', lineHeight: 1.2 }}>
                {subtitle}
            </Typography>
        </Box>
    );
};

const ModalAccionesDirEntrega = ({show, hideModal}) => {
    const theme = useTheme();
    const isDarkMode = theme.palette.mode === 'dark';
    const permisos = usePermisos();
    const handleClose = () => hideModal();

    const onOpenEditContacto = () => { handleClose(); showModal(ModalDirEntregaUpdate); }
    const onOpenNoVeoServicio = () => { handleClose(); showModal(ModalNoVeoServicio); }
    const onOpenValidarTarjeta = () => { handleClose(); showModal(ModalValidarTarjeta); }
    const onOpenCrearEventual = () => { handleClose(); showModal(ModalCrearClienteEventual); }
    const onOpenEliminarEventual = () => { handleClose(); showModal(ModalDeleteClienteEventual); }
    const onOpenBajaDebitoRechazado = () => { handleClose(); showModal(ModalBajaDebitoRechazado); }

    return(
        <Dialog open={show} disableEscapeKeyDown maxWidth='sm' fullWidth sx={{backdropFilter: 'blur(0.4px);'}}>
            <Box sx={{background: isDarkMode ? '#1F2A40' : '#fff'}}>
                <DialogTitleDefault id="add-canal-priv" onClose={handleClose}>
                    <Typography sx={{flex:1,textAlign: 'center', color: isDarkMode ? '#fff' : '#000',fontWeight: 'bold'}} variant='h5' component='span'>
                        ¿Que desea hacer?
                    </Typography>
                </DialogTitleDefault>
                <Divider sx={{background: isDarkMode ? '#3d4a62' : 'gray'}} />
                <DialogContent>
                    <Grid container spacing={2} sx={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                        <Grid item>
                            <AccionCard
                                icon={<PersonAddAlt1Icon fontSize='inherit' />}
                                title='EDITAR CONTACTO'
                                subtitle='Modificar datos del servicio'
                                onClick={onOpenEditContacto}
                                color='#1976d2'
                            />
                        </Grid>
                        <Grid item>
                            <AccionCard
                                icon={<PersonSearchIcon fontSize='inherit' />}
                                title='NO ENCUENTRO SERVICIO'
                                subtitle='Buscar servicio no listado'
                                onClick={onOpenNoVeoServicio}
                                color='#0288d1'
                            />
                        </Grid>
                        <Grid item>
                            <AccionCard
                                icon={<PaymentIcon fontSize='inherit' />}
                                title='VALIDAR TARJETA'
                                subtitle='Verificar datos de pago'
                                onClick={onOpenValidarTarjeta}
                                color='#7b1fa2'
                            />
                        </Grid>
                        {!permisos['permiso.enlaces.web'] && (
                          <>
                            <Grid item>
                                <AccionCard
                                    icon={<AddCircleOutlineIcon fontSize='inherit' />}
                                    title='CREAR EVENTUAL'
                                    subtitle='Nuevo servicio eventual'
                                    onClick={onOpenCrearEventual}
                                    color='#2e7d32'
                                    disabled={!permisos['created_eventual_softland']}
                                />
                            </Grid>
                            <Grid item>
                                <AccionCard
                                    icon={<DeleteForeverIcon fontSize='inherit' />}
                                    title='ELIMINAR EVENTUAL'
                                    subtitle='Eliminar servicio eventual'
                                    onClick={onOpenEliminarEventual}
                                    color='#d32f2f'
                                    disabled={!permisos['created_eventual_softland']}
                                />
                            </Grid>
                            <Grid item>
                                <AccionCard
                                    icon={<MoneyOffIcon fontSize='inherit' />}
                                    title='BAJA DÉBITO AUTOMÁTICO'
                                    subtitle='Débito rechazado'
                                    onClick={onOpenBajaDebitoRechazado}
                                    color='#ef6c00'
                                    disabled={!permisos['rechazo_da']}
                                />
                            </Grid>
                          </>
                        )}
                    </Grid>
                </DialogContent>
            </Box>
        </Dialog>
    )
}

export default ModalAccionesDirEntrega
